<template>
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.83203 18.6332V1.76758H16.1703V18.6332L9.11029 12.3086L1.83203 18.6332Z" stroke="currentColor" stroke-width="2.18667" stroke-linejoin="round" />
  </svg>
</template>
